import {
    setCookies
} from './_cookies';
import Cookies from 'js-cookie'

const checkForInternational = () => {
	if(Dillards.isInternational) return Dillards.isInternational;
    var returnValue, country = Cookies.get('zCountry'),
        noCountry = (country === null) || (country === undefined) || (country === '');
    if ((country !== 'US') || noCountry) {
        if (noCountry) {
            try {
                if (typeof zonos === 'object') {
                    zonos.changeCountry('US')
                } else {
                    var zonosInterval = setInterval(function () {
                        if (typeof zonos === 'object') {
                            zonos.changeCountry('US')
                            clearInterval(zonosInterval);
                        }
                    }, 250);

                    setTimeout(function () {
                        clearInterval(zonosInterval);
                    }, 5000);
                }
            } catch (e) {
                console.log(e);
            }
            setCookies('currency', 'USD');
            returnValue = false;
        } else {
            $('.header-espot').hide();
            returnValue = true;
        }
    } else {
        var currency = Cookies.get('currency');
        if ((currency === null) || (currency === undefined) || (currency === '')) setCookies('currency', 'USD');
        returnValue = false;
    }
    Dillards.isInternational = returnValue;
    return returnValue;
};

export {
    checkForInternational as isInternational 
}
